(function () {
  "use strict";

  var STORE_KEY = "afbd2eb0-431a-429e-90d6-437b746ebdbb";
  var API_BASE = "https://system.igmcore.pl/marketing/api/storefront/" + STORE_KEY;
  var PROMOTIONS_URL = API_BASE + "/promotions/";
  var PRODUCT_CAMPAIGNS_URL = API_BASE + "/product-campaigns/";
  var EVENT_URL = API_BASE + "/campaign-event/";

  var ROOT_ID = "igm-campaigns-root";
  var STORAGE_PREFIX = "igm_campaign_closed_";
  var VIEWED_PREFIX = "igm_campaign_viewed_";
  var FREQUENCY_PREFIX = "igm_campaign_seen_";
  var LAST_HOURS_LIMIT = 24;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  function safeText(value) {
    if (value === null || value === undefined) return "";
    return String(value).trim();
  }

  function safeNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function safeFloat(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function normalizeAlign(value, fallback) {
    var align = safeText(value || fallback || "center");

    if (
      align !== "left" &&
      align !== "center" &&
      align !== "right"
    ) {
      return fallback || "center";
    }

    return align;
  }

  function firstValue() {
    for (var i = 0; i < arguments.length; i += 1) {
      var value = arguments[i];

      if (
        value !== null &&
        value !== undefined &&
        safeText(value) !== ""
      ) {
        return value;
      }
    }

    return "";
  }

  function getConfig(element) {
    return (
      element &&
      element.configuration &&
      typeof element.configuration === "object"
    )
      ? element.configuration
      : {};
  }

  function getElementId(element) {
    return element.id || element.element_id || "";
  }

  function getElementType(element) {
    return safeText(
      element.element_type ||
      element.type ||
      element.kind
    );
  }

  function createRoot() {
    var existing = document.getElementById(ROOT_ID);

    if (existing) return existing;

    var root = document.createElement("div");

    root.id = ROOT_ID;
    root.className = "igm-campaigns-root";

    document.body.appendChild(root);

    return root;
  }

  function getContent(element) {
    return safeText(
      firstValue(
        element.content,
        getConfig(element).content,
        element.message
      )
    );
  }

  function getBackground(element) {
    return safeText(
      firstValue(
        element.background,
        element.background_color,
        getConfig(element).background_color,
        "#0f172a"
      )
    );
  }

  function getTextColor(element) {
    return safeText(
      firstValue(
        element.text_color,
        getConfig(element).text_color,
        "#ffffff"
      )
    );
  }

  function getButtonTextBase(element) {
    return safeText(
      firstValue(
        element.button_text,
        getConfig(element).button_text
      )
    );
  }

  function getButtonUrlBase(element) {
    return safeText(
      firstValue(
        element.button_url,
        getConfig(element).button_url
      )
    );
  }

  function getShowCta(element) {
    var cfg = getConfig(element);

    if (element.show_cta === false) return false;
    if (cfg.show_cta === false) return false;

    if (
      element.show_cta === 0 ||
      element.show_cta === "0"
    ) {
      return false;
    }

    if (
      cfg.show_cta === 0 ||
      cfg.show_cta === "0"
    ) {
      return false;
    }

    return true;
  }

  function getDeadline(element) {
    return safeText(
      firstValue(
        element.deadline,
        getConfig(element).deadline
      )
    );
  }

  function getExpiredContent(element) {
    return safeText(
      firstValue(
        element.expired_content,
        getConfig(element).expired_content
      )
    );
  }

  function parseDate(value) {
    var raw = safeText(value);

    if (!raw) return null;

    var date = new Date(raw);

    if (Number.isNaN(date.getTime())) {
      return null;
    }

    return date;
  }

  function getCampaignPhase(element) {
    var now = Date.now();

    var startAt = parseDate(
      firstValue(
        element.element_start_at,
        element.start_at,
        element.campaign_start_at,
        getConfig(element).element_start_at,
        getConfig(element).start_at
      )
    );

    var endAt = parseDate(
      firstValue(
        element.element_end_at,
        element.end_at,
        element.campaign_end_at,
        getConfig(element).element_end_at,
        getConfig(element).end_at,
        getDeadline(element)
      )
    );

    if (startAt && now < startAt.getTime()) {
      return "before_start";
    }

    if (endAt) {
      var diff = endAt.getTime() - now;

      if (diff <= 0) {
        return "after_end";
      }

      if (diff <= LAST_HOURS_LIMIT * 60 * 60 * 1000) {
        return "last_hours";
      }
    }

    return "active";
  }

  function normalizeState(state) {
    if (!state || typeof state !== "object") {
      return null;
    }

    var condition = safeText(
      state.condition ||
      state.phase ||
      "active"
    );

    if (
      condition !== "before_start" &&
      condition !== "active" &&
      condition !== "last_hours" &&
      condition !== "after_end"
    ) {
      condition = "active";
    }

    return {
      id: safeText(state.id),
      condition: condition,
      icon: safeText(state.icon),
      eyebrow: safeText(state.eyebrow),
      title: safeText(state.title),
      subtitle: safeText(state.subtitle),
      content: safeText(state.content),
      button_text: safeText(state.button_text),
      button_url: safeText(state.button_url),
      countdown_to: safeText(state.countdown_to),

      eyebrow_font_size: safeNumber(state.eyebrow_font_size, 12),
      eyebrow_line_height: safeFloat(state.eyebrow_line_height, 1.2),
      eyebrow_text_align: normalizeAlign(state.eyebrow_text_align, "center"),

      title_font_size: safeNumber(state.title_font_size, 26),
      title_line_height: safeFloat(state.title_line_height, 1.2),
      title_text_align: normalizeAlign(state.title_text_align, "center"),

      subtitle_font_size: safeNumber(state.subtitle_font_size, 18),
      subtitle_line_height: safeFloat(state.subtitle_line_height, 1.4),
      subtitle_text_align: normalizeAlign(state.subtitle_text_align, "center"),

      content_font_size: safeNumber(state.content_font_size, 16),
      content_line_height: safeFloat(state.content_line_height, 1.5),
      content_text_align: normalizeAlign(state.content_text_align, "center"),

      button_font_size: safeNumber(state.button_font_size, 14),
      button_text_align: normalizeAlign(state.button_text_align, "center"),

      enabled:
        state.enabled !== false &&
        state.is_active !== false &&
        state.active !== false
    };
  }

  function getStates(element) {
    var cfg = getConfig(element);
    var raw = [];

    if (Array.isArray(element.states)) {
      raw = element.states;
    } else if (Array.isArray(cfg.states)) {
      raw = cfg.states;
    }

    return raw
      .map(normalizeState)
      .filter(Boolean);
  }

  function getCurrentState(element) {
    var states = getStates(element).filter(function (state) {
      return state.enabled;
    });

    if (!states.length) {
      return null;
    }

    var phase = getCampaignPhase(element);

    var exact = states.find(function (state) {
      return state.condition === phase;
    });

    if (exact) {
      return exact;
    }

    if (phase === "last_hours") {
      var activeFallback = states.find(function (state) {
        return state.condition === "active";
      });

      if (activeFallback) {
        return activeFallback;
      }
    }

    return (
      states.find(function (state) {
        return state.condition === "active";
      }) ||
      states[0]
    );
  }

  /*
   * Kolejność:
   *
   * ikona
   * nadtytuł / eyebrow
   * tytuł
   * podtytuł
   * treść
   *
   * Każde puste pole jest całkowicie ignorowane.
   */
  function stateToText(state, compact) {
    if (!state) return "";

    return [
      state.icon,
      state.eyebrow,
      state.title,
      state.subtitle,
      state.content
    ]
      .map(safeText)
      .filter(Boolean)
      .join(compact ? " · " : "\n");
  }

  /*
   * Jeśli istnieje aktywna warstwa,
   * puste pola w niej są świadomie puste.
   *
   * Nie wracamy wtedy automatycznie
   * do głównej treści elementu.
   */
  function getElementText(element, compact) {
    var state = getCurrentState(element);

    if (state) {
      return stateToText(state, compact);
    }

    return getContent(element);
  }

  function getButtonText(element) {
    if (!getShowCta(element)) {
      return "";
    }

    var state = getCurrentState(element);

    if (state) {
      return safeText(state.button_text);
    }

    return getButtonTextBase(element);
  }

  function getButtonUrl(element) {
    if (!getShowCta(element)) {
      return "";
    }

    var state = getCurrentState(element);

    if (state) {
      return safeText(state.button_url);
    }

    return getButtonUrlBase(element);
  }

  function getBaseContentFontSize(element) {
    return Math.max(
      8,
      Math.min(
        safeNumber(getConfig(element).content_font_size, 16),
        72
      )
    );
  }

  function getBaseContentLineHeight(element) {
    return Math.max(
      0.8,
      Math.min(
        safeFloat(getConfig(element).content_line_height, 1.5),
        3
      )
    );
  }

  function getBaseContentTextAlign(element) {
    return normalizeAlign(
      getConfig(element).content_text_align,
      "center"
    );
  }

  function getButtonFontSize(element) {
    var state = getCurrentState(element);

    return Math.max(
      8,
      Math.min(
        state
          ? safeNumber(state.button_font_size, 14)
          : safeNumber(getConfig(element).button_font_size, 14),
        40
      )
    );
  }

  function getButtonTextAlign(element) {
    var state = getCurrentState(element);

    return normalizeAlign(
      state
        ? state.button_text_align
        : getConfig(element).button_text_align,
      "center"
    );
  }

  function getFooterText(element) {
    return safeText(
      firstValue(
        element.footer_text,
        getConfig(element).footer_text
      )
    );
  }

  function getFooterFontSize(element) {
    return Math.max(
      8,
      Math.min(
        safeNumber(
          firstValue(
            element.footer_font_size,
            getConfig(element).footer_font_size,
            11
          ),
          11
        ),
        40
      )
    );
  }

  function getFooterLineHeight(element) {
    return Math.max(
      0.8,
      Math.min(
        safeFloat(
          firstValue(
            element.footer_line_height,
            getConfig(element).footer_line_height,
            1.4
          ),
          1.4
        ),
        3
      )
    );
  }

  function getFooterTextAlign(element) {
    return normalizeAlign(
      firstValue(
        element.footer_text_align,
        getConfig(element).footer_text_align,
        "center"
      ),
      "center"
    );
  }

  function isEmbeddedCountdownEnabled(element) {
    var value = firstValue(
      element.embedded_countdown_enabled,
      getConfig(element).embedded_countdown_enabled
    );

    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true"
    );
  }

  function getEmbeddedCountdownPosition(element) {
    var position = safeText(
      firstValue(
        element.embedded_countdown_position,
        getConfig(element).embedded_countdown_position,
        "after_content"
      )
    );

    if (
      position !== "before_content" &&
      position !== "after_content" &&
      position !== "before_actions" &&
      position !== "after_actions"
    ) {
      position = "after_content";
    }

    return position;
  }

  function getEmbeddedCountdownDeadline(element) {
    return parseDate(
      firstValue(
        element.embedded_countdown_deadline,
        getConfig(element).embedded_countdown_deadline
      )
    );
  }

  function getEmbeddedCountdownShowDays(element) {
    var value = firstValue(
      element.embedded_countdown_show_days,
      getConfig(element).embedded_countdown_show_days
    );

    return value !== false && value !== 0 && value !== "0";
  }

  function getEmbeddedCountdownShowSeconds(element) {
    var value = firstValue(
      element.embedded_countdown_show_seconds,
      getConfig(element).embedded_countdown_show_seconds
    );

    return value !== false && value !== 0 && value !== "0";
  }

  function applyTextStyle(node, fontSize, lineHeight, align) {
    if (!node) return;

    node.style.fontSize = String(fontSize) + "px";
    node.style.lineHeight = String(lineHeight);
    node.style.textAlign = normalizeAlign(align, "center");
  }

  function makeStateTextNode(className, text, fontSize, lineHeight, align) {
    var value = safeText(text);

    if (!value) {
      return null;
    }

    var node = document.createElement("div");

    node.className = className;
    node.textContent = value;

    applyTextStyle(
      node,
      fontSize,
      lineHeight,
      align
    );

    return node;
  }

  function makeElementContent(element, variant) {
    var state = getCurrentState(element);
    var host = document.createElement("div");

    host.className =
      "igm-campaign-content igm-campaign-content--" +
      safeText(variant || "default");

    if (!state) {
      var base = getContent(element);

      if (!base) {
        return null;
      }

      host.textContent = base;

      applyTextStyle(
        host,
        getBaseContentFontSize(element),
        getBaseContentLineHeight(element),
        getBaseContentTextAlign(element)
      );

      return host;
    }

    host.classList.add("igm-campaign-content--structured");

    if (state.icon) {
      var icon = document.createElement("div");

      icon.className = "igm-campaign-state-icon";
      icon.textContent = state.icon;
      icon.style.textAlign = normalizeAlign(
        state.eyebrow_text_align ||
        state.title_text_align,
        "center"
      );

      host.appendChild(icon);
    }

    var eyebrow = makeStateTextNode(
      "igm-campaign-state-eyebrow",
      state.eyebrow,
      state.eyebrow_font_size,
      state.eyebrow_line_height,
      state.eyebrow_text_align
    );

    var title = makeStateTextNode(
      "igm-campaign-state-title",
      state.title,
      state.title_font_size,
      state.title_line_height,
      state.title_text_align
    );

    var subtitle = makeStateTextNode(
      "igm-campaign-state-subtitle",
      state.subtitle,
      state.subtitle_font_size,
      state.subtitle_line_height,
      state.subtitle_text_align
    );

    var content = makeStateTextNode(
      "igm-campaign-state-content",
      state.content,
      state.content_font_size,
      state.content_line_height,
      state.content_text_align
    );

    [
      eyebrow,
      title,
      subtitle,
      content
    ].forEach(function (node) {
      if (node) {
        host.appendChild(node);
      }
    });

    if (!host.childNodes.length) {
      return null;
    }

    return host;
  }

  function makeFooter(element) {
    var text = getFooterText(element);

    if (!text) {
      return null;
    }

    var footer = document.createElement("div");

    footer.className = "igm-campaign-footer";
    footer.textContent = text;

    applyTextStyle(
      footer,
      getFooterFontSize(element),
      getFooterLineHeight(element),
      getFooterTextAlign(element)
    );

    return footer;
  }

  function getTimeLeftForDate(deadline) {
    if (!deadline) {
      return null;
    }

    var diff = Math.max(
      0,
      deadline.getTime() - Date.now()
    );

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);

    totalSeconds -= days * 86400;

    var hours = Math.floor(totalSeconds / 3600);
    totalSeconds -= hours * 3600;

    var minutes = Math.floor(totalSeconds / 60);
    totalSeconds -= minutes * 60;

    return {
      expired: diff <= 0,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: totalSeconds
    };
  }

  function getDiscountCode(element) {
    return safeText(
      firstValue(
        element.discount_code,
        getConfig(element).discount_code
      )
    );
  }

  function getDiscountLabel(element) {
    return safeText(
      firstValue(
        element.discount_label,
        getConfig(element).discount_label,
        "Kod rabatowy"
      )
    );
  }

  function getDiscountMode(element) {
    var mode = safeText(
      firstValue(
        element.discount_mode,
        getConfig(element).discount_mode,
        "hidden"
      )
    );

    if (
      mode !== "hidden" &&
      mode !== "show_code" &&
      mode !== "copy_code" &&
      mode !== "cta_only"
    ) {
      mode = "hidden";
    }

    return mode;
  }

  function getDiscountBackgroundColor(element) {
    return safeText(
      firstValue(
        element.discount_background_color,
        getConfig(element).discount_background_color,
        "#ffffff"
      )
    );
  }

  function getDiscountTextColor(element) {
    return safeText(
      firstValue(
        element.discount_text_color,
        getConfig(element).discount_text_color,
        "#0f172a"
      )
    );
  }

  function getDiscountBorderColor(element) {
    return safeText(
      firstValue(
        element.discount_border_color,
        getConfig(element).discount_border_color,
        "#cbd5e1"
      )
    );
  }

  function getDiscountButtonBackgroundColor(element) {
    return safeText(
      firstValue(
        element.discount_button_background_color,
        getConfig(element).discount_button_background_color,
        "#ffffff"
      )
    );
  }

  function getDiscountButtonTextColor(element) {
    return safeText(
      firstValue(
        element.discount_button_text_color,
        getConfig(element).discount_button_text_color,
        "#0f172a"
      )
    );
  }

  function getDiscountBorderRadius(element) {
    var value = safeNumber(
      firstValue(
        element.discount_border_radius,
        getConfig(element).discount_border_radius,
        14
      ),
      14
    );

    return Math.max(
      0,
      Math.min(value, 40)
    );
  }

  function getDiscountCodeFontSize(element) {
    var value = safeNumber(
      firstValue(
        element.discount_code_font_size,
        getConfig(element).discount_code_font_size,
        18
      ),
      18
    );

    return Math.max(
      10,
      Math.min(value, 32)
    );
  }

  function getDiscountLabelFontSize(element) {
    var value = safeNumber(
      firstValue(
        element.discount_label_font_size,
        getConfig(element).discount_label_font_size,
        10
      ),
      10
    );

    return Math.max(
      8,
      Math.min(value, 24)
    );
  }

  function getSourcePath() {
    return (
      window.location.pathname +
      window.location.search
    );
  }

  function getDevice() {
    return window.innerWidth <= 767
      ? "mobile"
      : "desktop";
  }

  function storageKey(prefix, element) {
    return prefix + String(getElementId(element));
  }

  function isDebugMode() {
    return (
      window.location.search.indexOf(
        "igm_campaign_debug=1"
      ) !== -1
    );
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {}
  }

  function wasClosed(element) {
    if (isDebugMode()) {
      return false;
    }

    return (
      storageGet(
        window.sessionStorage,
        storageKey(STORAGE_PREFIX, element)
      ) === "1"
    );
  }

  function markClosed(element) {
    storageSet(
      window.sessionStorage,
      storageKey(STORAGE_PREFIX, element),
      "1"
    );
  }

  function isDeviceAllowed(element) {
    var target = safeText(
      element.device_target ||
      getConfig(element).device_target ||
      "all"
    );

    var mobile =
      window.matchMedia &&
      window.matchMedia("(max-width: 749px)").matches;

    if (target === "mobile") {
      return mobile;
    }

    if (target === "desktop") {
      return !mobile;
    }

    return true;
  }

  function isPathAllowed(element) {
    var path = window.location.pathname || "/";

    var includes = Array.isArray(element.url_include_paths)
      ? element.url_include_paths
      : getConfig(element).url_include_paths;

    var excludes = Array.isArray(element.url_exclude_paths)
      ? element.url_exclude_paths
      : getConfig(element).url_exclude_paths;

    includes = Array.isArray(includes)
      ? includes.map(safeText).filter(Boolean)
      : [];

    excludes = Array.isArray(excludes)
      ? excludes.map(safeText).filter(Boolean)
      : [];

    if (
      includes.length &&
      !includes.some(function (rule) {
        return path.indexOf(rule) === 0;
      })
    ) {
      return false;
    }

    if (
      excludes.some(function (rule) {
        return path.indexOf(rule) === 0;
      })
    ) {
      return false;
    }

    return true;
  }

  function isFrequencyAllowed(element) {
    if (isDebugMode()) {
      return true;
    }

    var mode = safeText(
      element.display_frequency ||
      getConfig(element).display_frequency ||
      "session"
    );

    var key = storageKey(
      FREQUENCY_PREFIX,
      element
    );

    if (mode === "always") {
      return true;
    }

    if (mode === "session") {
      if (
        storageGet(
          window.sessionStorage,
          key
        )
      ) {
        return false;
      }

      storageSet(
        window.sessionStorage,
        key,
        "1"
      );

      return true;
    }

    if (mode === "day") {
      var today = new Date()
        .toISOString()
        .slice(0, 10);

      if (
        storageGet(
          window.localStorage,
          key
        ) === today
      ) {
        return false;
      }

      storageSet(
        window.localStorage,
        key,
        today
      );

      return true;
    }

    if (mode === "user") {
      if (
        storageGet(
          window.localStorage,
          key
        )
      ) {
        return false;
      }

      storageSet(
        window.localStorage,
        key,
        String(Date.now())
      );

      return true;
    }

    return true;
  }

  function canRenderElement(element, useFrequency) {
    if (!element) return false;
    if (!getElementId(element)) return false;
    if (!isDeviceAllowed(element)) return false;
    if (!isPathAllowed(element)) return false;
    if (wasClosed(element)) return false;

    if (
      useFrequency &&
      !isFrequencyAllowed(element)
    ) {
      return false;
    }

    return true;
  }

  function eventPayload(element, eventType, targetUrl) {
    return {
      event_type: eventType,
      element_id: getElementId(element),
      campaign_id: element.campaign_id || "",

      label: safeText(
        element.name ||
        element.label ||
        getElementText(element, true)
      ).slice(0, 160),

      target_url:
        targetUrl ||
        getButtonUrl(element),

      source_path: getSourcePath(),
      page_url: window.location.href,
      path: window.location.pathname,
      device: getDevice(),
      viewport_width: window.innerWidth
    };
  }

  function sendEvent(element, eventType, targetUrl) {
    if (
      !getElementId(element) ||
      !eventType
    ) {
      return;
    }

    if (eventType === "view") {
      var viewKey =
        storageKey(
          VIEWED_PREFIX,
          element
        ) +
        "_" +
        getSourcePath();

      if (
        storageGet(
          window.sessionStorage,
          viewKey
        )
      ) {
        return;
      }

      storageSet(
        window.sessionStorage,
        viewKey,
        "1"
      );
    }

    var payload = JSON.stringify(
      eventPayload(
        element,
        eventType,
        targetUrl
      )
    );

    if (navigator.sendBeacon) {
      try {
        navigator.sendBeacon(
          EVENT_URL,
          new Blob(
            [payload],
            {
              type: "application/json"
            }
          )
        );

        return;
      } catch (error) {}
    }

    fetch(
      EVENT_URL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: payload,
        keepalive: true
      }
    ).catch(function () {});
  }

  function applyColors(node, element) {
    node.style.background =
      getBackground(element);

    node.style.color =
      getTextColor(element);
  }

  function makeButton(element) {
    if (!getShowCta(element)) {
      return null;
    }

    var text = getButtonText(element);
    var url = getButtonUrl(element);

    if (!text || !url) {
      return null;
    }

    var button =
      document.createElement("a");

    button.className =
      "igm-campaign-button";

    button.href = url;
    button.textContent = text;

    button.style.fontSize =
      getButtonFontSize(element) + "px";

    button.setAttribute(
      "data-align",
      getButtonTextAlign(element)
    );

    button.addEventListener(
      "click",
      function () {
        sendEvent(
          element,
          "click",
          url
        );
      }
    );

    return button;
  }

  function copyToClipboard(text) {
    if (
      navigator.clipboard &&
      navigator.clipboard.writeText
    ) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var input =
          document.createElement("textarea");

        input.value = text;

        input.setAttribute(
          "readonly",
          "readonly"
        );

        input.style.position = "fixed";
        input.style.left = "-9999px";

        document.body.appendChild(input);

        input.select();

        var successful =
          document.execCommand("copy");

        input.remove();

        if (successful) {
          resolve();
        } else {
          reject(
            new Error("copy command failed")
          );
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  function makeDiscount(element) {
    var code = getDiscountCode(element);
    var mode = getDiscountMode(element);

    if (
      !code ||
      mode === "hidden" ||
      mode === "cta_only"
    ) {
      return null;
    }

    var wrapper =
      document.createElement("div");

    wrapper.className =
      "igm-campaign-discount";

    var label =
      document.createElement("span");

    label.className =
      "igm-campaign-discount__label";

    label.textContent =
      getDiscountLabel(element);

    label.style.fontSize =
      getDiscountLabelFontSize(element) +
      "px";

    var voucher =
      document.createElement("div");

    voucher.className =
      "igm-campaign-discount__voucher";

    voucher.style.backgroundColor =
      getDiscountBackgroundColor(element);

    voucher.style.color =
      getDiscountTextColor(element);

    voucher.style.borderColor =
      getDiscountBorderColor(element);

    voucher.style.borderRadius =
      getDiscountBorderRadius(element) +
      "px";

    var codeNode =
      document.createElement("span");

    codeNode.className =
      "igm-campaign-discount__code";

    codeNode.textContent = code;

    codeNode.style.fontSize =
      getDiscountCodeFontSize(element) +
      "px";

    voucher.appendChild(codeNode);

    if (mode === "copy_code") {
      var copy =
        document.createElement("button");

      copy.type = "button";

      copy.className =
        "igm-campaign-discount__copy";

      copy.textContent = "Kopiuj";

      copy.style.backgroundColor =
        getDiscountButtonBackgroundColor(
          element
        );

      copy.style.color =
        getDiscountButtonTextColor(
          element
        );

      copy.style.borderColor =
        getDiscountBorderColor(element);

      copy.style.borderRadius =
        Math.max(
          6,
          getDiscountBorderRadius(element) - 4
        ) +
        "px";

      copy.setAttribute(
        "aria-label",
        "Skopiuj kod rabatowy " + code
      );

      var copying = false;

      var performCopy = function () {
        if (copying) {
          return;
        }

        copying = true;

        copyToClipboard(code)
          .then(function () {
            copy.textContent =
              "✓ Skopiowano";

            wrapper.classList.add(
              "is-copied"
            );

            sendEvent(
              element,
              "click"
            );

            window.setTimeout(
              function () {
                copy.textContent =
                  "Kopiuj";

                wrapper.classList.remove(
                  "is-copied"
                );

                copying = false;
              },
              1800
            );
          })
          .catch(function () {
            copy.textContent =
              "Skopiuj ręcznie";

            wrapper.classList.remove(
              "is-copied"
            );

            window.setTimeout(
              function () {
                copy.textContent =
                  "Kopiuj";

                copying = false;
              },
              2200
            );
          });
      };

      copy.addEventListener(
        "click",
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          performCopy();
        }
      );

      codeNode.setAttribute(
        "role",
        "button"
      );

      codeNode.setAttribute(
        "tabindex",
        "0"
      );

      codeNode.setAttribute(
        "aria-label",
        "Skopiuj kod rabatowy " + code
      );

      codeNode.classList.add(
        "is-copyable"
      );

      codeNode.addEventListener(
        "click",
        performCopy
      );

      codeNode.addEventListener(
        "keydown",
        function (event) {
          if (
            event.key === "Enter" ||
            event.key === " "
          ) {
            event.preventDefault();
            performCopy();
          }
        }
      );

      voucher.appendChild(copy);
    }

    if (label.textContent) {
      wrapper.appendChild(label);
    }

    wrapper.appendChild(voucher);

    return wrapper;
  }

  function makeEmbeddedCountdown(element) {
    if (!isEmbeddedCountdownEnabled(element)) {
      return null;
    }

    var deadline =
      getEmbeddedCountdownDeadline(element);

    var initial =
      getTimeLeftForDate(deadline);

    if (
      !deadline ||
      !initial ||
      initial.expired
    ) {
      return null;
    }

    var wrapper =
      document.createElement("div");

    wrapper.className =
      "igm-campaign-embedded-countdown";

    var values =
      document.createElement("div");

    values.className =
      "igm-campaign-embedded-countdown__values";

    var days =
      makeTimeBox(
        "dni",
        initial.days
      );

    var hours =
      makeTimeBox(
        "godz.",
        pad(initial.hours)
      );

    var minutes =
      makeTimeBox(
        "min",
        pad(initial.minutes)
      );

    var seconds =
      makeTimeBox(
        "sek",
        pad(initial.seconds)
      );

    if (getEmbeddedCountdownShowDays(element)) {
      values.appendChild(days.item);
    }

    values.appendChild(hours.item);
    values.appendChild(minutes.item);

    if (getEmbeddedCountdownShowSeconds(element)) {
      values.appendChild(seconds.item);
    }

    wrapper.appendChild(values);

    var interval =
      window.setInterval(
        function () {
          if (!document.documentElement.contains(wrapper)) {
            window.clearInterval(interval);
            return;
          }

          var next =
            getTimeLeftForDate(deadline);

          if (
            !next ||
            next.expired
          ) {
            window.clearInterval(interval);

            if (wrapper.parentNode) {
              wrapper.parentNode.removeChild(wrapper);
            }

            return;
          }

          days.number.textContent =
            String(next.days);

          hours.number.textContent =
            pad(next.hours);

          minutes.number.textContent =
            pad(next.minutes);

          seconds.number.textContent =
            pad(next.seconds);
        },
        1000
      );

    return wrapper;
  }

  function appendElementLayout(
    parent,
    element,
    contentNode,
    actionsNode
  ) {
    var embedded =
      makeEmbeddedCountdown(element);

    var position =
      getEmbeddedCountdownPosition(element);

    if (
      embedded &&
      position === "before_content"
    ) {
      parent.appendChild(embedded);
      embedded = null;
    }

    if (contentNode) {
      parent.appendChild(contentNode);
    }

    if (
      embedded &&
      position === "after_content"
    ) {
      parent.appendChild(embedded);
      embedded = null;
    }

    if (
      embedded &&
      position === "before_actions"
    ) {
      parent.appendChild(embedded);
      embedded = null;
    }

    if (
      actionsNode &&
      actionsNode.childNodes.length
    ) {
      parent.appendChild(actionsNode);
    }

    if (
      embedded &&
      position === "after_actions"
    ) {
      parent.appendChild(embedded);
      embedded = null;
    }

    if (embedded) {
      parent.appendChild(embedded);
    }

    var footer =
      makeFooter(element);

    if (footer) {
      parent.appendChild(footer);
    }

    return Boolean(
      contentNode ||
      (
        actionsNode &&
        actionsNode.childNodes.length
      ) ||
      parent.querySelector(
        ".igm-campaign-embedded-countdown"
      ) ||
      footer
    );
  }

  function appendActions(parent, element) {
    var discount =
      makeDiscount(element);

    var button =
      makeButton(element);

    if (discount) {
      parent.appendChild(discount);
    }

    if (button) {
      parent.appendChild(button);
    }
  }

  function makeCloseButton(element, container) {
    var close =
      document.createElement("button");

    close.type = "button";

    close.className =
      "igm-campaign-close";

    close.setAttribute(
      "aria-label",
      "Zamknij"
    );

    close.textContent = "×";

    close.addEventListener(
      "click",
      function () {
        markClosed(element);

        sendEvent(
          element,
          "close"
        );

        if (
          container &&
          container.parentNode
        ) {
          container.parentNode.removeChild(
            container
          );
        }
      }
    );

    return close;
  }

  /*
   * Próba znalezienia istniejącej
   * górnej belki / announcement bara sklepu.
   */
  function isVisibleElement(element) {
    if (!element) {
      return false;
    }

    var style =
      window.getComputedStyle(element);

    if (
      style.display === "none" ||
      style.visibility === "hidden"
    ) {
      return false;
    }

    var rect =
      element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function findAnnouncementBar() {
    var selectors = [
      ".announcement-bar-section",
      ".announcement-bar",
      "[class*='announcement-bar']",
      "[class*='AnnouncementBar']",
      "[id*='announcement-bar']",
      "[id*='AnnouncementBar']",
      "[class*='announcement']",
      "[id*='announcement']"
    ];

    for (
      var i = 0;
      i < selectors.length;
      i += 1
    ) {
      var candidates =
        document.querySelectorAll(
          selectors[i]
        );

      for (
        var j = 0;
        j < candidates.length;
        j += 1
      ) {
        var candidate =
          candidates[j];

        if (
          candidate.closest &&
          candidate.closest(
            "#" + ROOT_ID
          )
        ) {
          continue;
        }

        if (!isVisibleElement(candidate)) {
          continue;
        }

        var rect =
          candidate.getBoundingClientRect();

        if (
          rect.top <= 120 &&
          rect.height >= 16 &&
          rect.height <= 120 &&
          rect.width >=
            window.innerWidth * 0.45
        ) {
          return candidate;
        }
      }
    }

    return null;
  }

  function placeTopBar(bar) {
    var announcement =
      findAnnouncementBar();

    if (
      announcement &&
      announcement.parentNode
    ) {
      announcement.parentNode.insertBefore(
        bar,
        announcement.nextSibling
      );

      return;
    }

    if (document.body.firstChild) {
      document.body.insertBefore(
        bar,
        document.body.firstChild
      );

      return;
    }

    document.body.appendChild(bar);
  }

  function renderBar(root, element, position) {
    var bar =
      document.createElement("div");

    bar.className =
      position === "top"
        ? "igm-campaign-top-bar"
        : "igm-campaign-bottom-bar";

    applyColors(
      bar,
      element
    );

    var content =
      makeElementContent(
        element,
        "bar"
      );

    if (content) {
      content.classList.add(
        "igm-campaign-bar-text"
      );
    }

    var actions =
      document.createElement("div");

    actions.className =
      "igm-campaign-bar-actions";

    appendActions(
      actions,
      element
    );

    if (
      !appendElementLayout(
        bar,
        element,
        content,
        actions
      )
    ) {
      return false;
    }

    bar.appendChild(
      makeCloseButton(
        element,
        bar
      )
    );

    if (position === "top") {
      placeTopBar(bar);
    } else {
      root.appendChild(bar);
    }

    sendEvent(
      element,
      "view"
    );

    return true;
  }

  function renderPopup(root, element) {
    var delay = safeNumber(
      element.popup_delay_seconds ||
      getConfig(element).popup_delay_seconds,
      0
    );

    if (delay < 0) {
      delay = 0;
    }

    window.setTimeout(
      function () {
        if (wasClosed(element)) {
          return;
        }

        var overlay =
          document.createElement("div");

        overlay.className =
          "igm-campaign-popup-overlay";

        var popup =
          document.createElement("div");

        popup.className =
          "igm-campaign-popup";

        applyColors(
          popup,
          element
        );

        var content =
          makeElementContent(
            element,
            "popup"
          );

        if (content) {
          content.classList.add(
            "igm-campaign-popup-content"
          );
        }

        var actions =
          document.createElement("div");

        actions.className =
          "igm-campaign-popup-actions";

        appendActions(
          actions,
          element
        );

        popup.appendChild(
          makeCloseButton(
            element,
            overlay
          )
        );

        if (
          !appendElementLayout(
            popup,
            element,
            content,
            actions
          )
        ) {
          return;
        }

        overlay.appendChild(popup);
        root.appendChild(overlay);

        sendEvent(
          element,
          "view"
        );
      },
      delay * 1000
    );

    return true;
  }

  function getDeadlineDate(element) {
    var state =
      getCurrentState(element);

    var raw = safeText(
      firstValue(
        state && state.countdown_to,
        getDeadline(element)
      )
    );

    return parseDate(raw);
  }

  function getTimeLeft(element) {
    return getTimeLeftForDate(
      getDeadlineDate(element)
    );
  }

  function makeTimeBox(label, value) {
    var item =
      document.createElement("div");

    item.className =
      "igm-campaign-countdown-box";

    var number =
      document.createElement("span");

    number.className =
      "igm-campaign-countdown-number";

    number.textContent =
      value;

    var labelNode =
      document.createElement("span");

    labelNode.className =
      "igm-campaign-countdown-label";

    labelNode.textContent =
      label;

    item.appendChild(number);
    item.appendChild(labelNode);

    return {
      item: item,
      number: number
    };
  }

  function pad(value) {
    return String(value)
      .padStart(2, "0");
  }

  function renderCountdown(root, element) {
    var phase =
      getCampaignPhase(element);

    var time =
      getTimeLeft(element);

    var afterText =
      getElementText(
        element,
        false
      ) ||
      getExpiredContent(element);

    if (
      phase === "after_end" &&
      !afterText
    ) {
      return false;
    }

    if (
      phase !== "after_end" &&
      (!time || time.expired)
    ) {
      return false;
    }

    var box =
      document.createElement("div");

    box.className =
      "igm-campaign-countdown";

    applyColors(
      box,
      element
    );

    var header =
      document.createElement("div");

    header.className =
      "igm-campaign-countdown-header";

    var contentHost =
      document.createElement("div");

    contentHost.className =
      "igm-campaign-countdown-title";

    function refreshContent() {
      contentHost.textContent = "";

      var content =
        makeElementContent(
          element,
          "countdown"
        );

      if (content) {
        contentHost.appendChild(content);
        return true;
      }

      var fallback =
        getExpiredContent(element) ||
        "Promocja kończy się za";

      if (fallback) {
        contentHost.textContent =
          fallback;

        return true;
      }

      return false;
    }

    refreshContent();

    header.appendChild(contentHost);

    header.appendChild(
      makeCloseButton(
        element,
        box
      )
    );

    box.appendChild(header);

    var values =
      document.createElement("div");

    values.className =
      "igm-campaign-countdown-values";

    var days =
      makeTimeBox(
        "dni",
        time ? time.days : 0
      );

    var hours =
      makeTimeBox(
        "godz.",
        time
          ? pad(time.hours)
          : "00"
      );

    var minutes =
      makeTimeBox(
        "min",
        time
          ? pad(time.minutes)
          : "00"
      );

    var seconds =
      makeTimeBox(
        "sek",
        time
          ? pad(time.seconds)
          : "00"
      );

    if (element.show_days !== false) {
      values.appendChild(days.item);
    }

    values.appendChild(hours.item);
    values.appendChild(minutes.item);

    if (
      element.show_seconds !== false
    ) {
      values.appendChild(seconds.item);
    }

    if (phase !== "after_end") {
      box.appendChild(values);
    }

    var actions =
      document.createElement("div");

    actions.className =
      "igm-campaign-countdown-actions";

    appendActions(
      actions,
      element
    );

    if (actions.childNodes.length) {
      box.appendChild(actions);
    }

    var footer =
      makeFooter(element);

    if (footer) {
      box.appendChild(footer);
    }

    root.appendChild(box);

    sendEvent(
      element,
      "view"
    );

    if (phase === "after_end") {
      return true;
    }

    var interval =
      window.setInterval(
        function () {
          var next =
            getTimeLeft(element);

          if (
            !next ||
            next.expired
          ) {
            window.clearInterval(
              interval
            );

            var afterState =
              getStates(element)
                .find(function (state) {
                  return (
                    state.enabled &&
                    state.condition ===
                      "after_end"
                  );
                });

            var expired =
              getExpiredContent(
                element
              );

            if (
              afterState ||
              expired
            ) {
              refreshContent();

              if (values.parentNode) {
                values.parentNode.removeChild(
                  values
                );
              }
            } else if (
              box.parentNode
            ) {
              box.parentNode.removeChild(
                box
              );
            }

            return;
          }

          days.number.textContent =
            next.days;

          hours.number.textContent =
            pad(next.hours);

          minutes.number.textContent =
            pad(next.minutes);

          seconds.number.textContent =
            pad(next.seconds);
        },
        1000
      );

    return true;
  }

  function normalizeElement(element, campaign) {
    var normalized = {};

    Object.keys(
      element || {}
    ).forEach(function (key) {
      normalized[key] =
        element[key];
    });

    normalized.campaign_id =
      campaign &&
      campaign.id
        ? campaign.id
        : normalized.campaign_id;

    normalized.priority =
      campaign &&
      campaign.priority
        ? campaign.priority
        : normalized.priority;

    return normalized;
  }

  function collectPromotionElements(data) {
    var output = [];
    var campaigns = [];

    if (
      Array.isArray(
        data.promotions
      )
    ) {
      campaigns =
        data.promotions;
    } else if (
      Array.isArray(
        data.campaigns
      )
    ) {
      campaigns =
        data.campaigns;
    }

    campaigns.forEach(
      function (campaign) {
        if (
          Array.isArray(
            campaign.elements
          )
        ) {
          campaign.elements.forEach(
            function (element) {
              output.push(
                normalizeElement(
                  element,
                  campaign
                )
              );
            }
          );
        }
      }
    );

    return output;
  }

  function sortElements(elements) {
    return elements
      .slice()
      .sort(function (a, b) {
        var ap = safeNumber(
          a.priority ||
          a.position,
          100
        );

        var bp = safeNumber(
          b.priority ||
          b.position,
          100
        );

        if (ap !== bp) {
          return ap - bp;
        }

        return (
          safeNumber(
            getElementId(a),
            0
          ) -
          safeNumber(
            getElementId(b),
            0
          )
        );
      });
  }

  function loadPromotions() {
    fetch(
      PROMOTIONS_URL +
      "?t=" +
      Date.now(),
      {
        method: "GET",
        headers: {
          Accept:
            "application/json"
        },
        credentials: "omit",
        cache: "no-store"
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Campaign API status " +
            response.status
          );
        }

        return response.json();
      })
      .then(function (data) {
        var root =
          createRoot();

        var elements =
          sortElements(
            collectPromotionElements(
              data
            )
          );

        var topRendered = false;
        var bottomRendered = false;
        var popupRendered = false;
        var countdownRendered = false;

        elements.forEach(
          function (element) {
            var type =
              getElementType(
                element
              );

            if (
              type === "top_bar" &&
              !topRendered &&
              canRenderElement(
                element,
                false
              )
            ) {
              topRendered =
                renderBar(
                  root,
                  element,
                  "top"
                ) ||
                topRendered;

              return;
            }

            if (
              type === "bottom_bar" &&
              !bottomRendered &&
              canRenderElement(
                element,
                false
              )
            ) {
              bottomRendered =
                renderBar(
                  root,
                  element,
                  "bottom"
                ) ||
                bottomRendered;

              return;
            }

            if (
              type === "popup" &&
              !popupRendered &&
              canRenderElement(
                element,
                true
              )
            ) {
              popupRendered =
                renderPopup(
                  root,
                  element
                ) ||
                popupRendered;

              return;
            }

            if (
              type === "countdown" &&
              !countdownRendered &&
              canRenderElement(
                element,
                false
              )
            ) {
              countdownRendered =
                renderCountdown(
                  root,
                  element
                ) ||
                countdownRendered;
            }
          }
        );
      })
      .catch(function (error) {
        if (
          window.console &&
          window.console.warn
        ) {
          window.console.warn(
            "[IGM campaigns]",
            error
          );
        }
      });
  }

  function normalizeHandle(value) {
    var raw = safeText(value)
      .replace(
        /^https?:\/\/[^/]+/i,
        ""
      )
      .split("?")[0]
      .split("#")[0]
      .replace(
        /^\/+|\/+$/g,
        ""
      );

    if (
      raw.indexOf(
        "collections/"
      ) === 0
    ) {
      raw = raw.replace(
        "collections/",
        ""
      );
    }

    if (
      raw.indexOf(
        "products/"
      ) === 0
    ) {
      raw = raw.replace(
        "products/",
        ""
      );
    }

    return raw;
  }

  function normalizeHandleList(values) {
    if (!Array.isArray(values)) {
      return [];
    }

    return values
      .map(normalizeHandle)
      .filter(Boolean);
  }

  function getProductHandleFromUrl() {
    var match =
      window.location.pathname.match(
        /\/products\/([^/?#]+)/
      );

    return match
      ? normalizeHandle(
          match[1]
        )
      : "";
  }

  function getCollectionHandleFromUrl() {
    var match =
      window.location.pathname.match(
        /\/collections\/([^/?#]+)/
      );

    return match
      ? normalizeHandle(
          match[1]
        )
      : "";
  }

  function getProductHandleFromLink(link) {
    var href = safeText(
      link &&
      link.getAttribute(
        "href"
      )
    );

    var match = href.match(
      /\/products\/([^/?#]+)/
    );

    return match
      ? normalizeHandle(
          match[1]
        )
      : "";
  }

  function productElementMatches(
    element,
    linkedProductHandle
  ) {
    var cfg =
      getConfig(element);

    var scope = safeText(
      element.product_scope ||
      cfg.product_scope ||
      "all"
    );

    var productHandle =
      safeText(
        linkedProductHandle
      ) ||
      getProductHandleFromUrl();

    var collectionHandle =
      getCollectionHandleFromUrl();

    var productHandles =
      normalizeHandleList(
        element.product_handles ||
        cfg.product_handles
      );

    var collectionHandles =
      normalizeHandleList(
        element.collection_handles ||
        cfg.collection_handles
      );

    var resolvedProductHandles =
      normalizeHandleList(
        element.resolved_product_handles ||
        cfg.resolved_product_handles
      );

    if (
      scope === "all" ||
      scope === "wszystkie" ||
      scope === "all_products"
    ) {
      return true;
    }

    if (
      scope === "products" ||
      scope === "product" ||
      scope === "selected_products"
    ) {
      return (
        productHandle &&
        productHandles.indexOf(
          productHandle
        ) !== -1
      );
    }

    if (
      scope === "collections" ||
      scope === "collection" ||
      scope === "selected_collections"
    ) {
      if (
        productHandle &&
        resolvedProductHandles.indexOf(
          productHandle
        ) !== -1
      ) {
        return true;
      }

      return (
        collectionHandle &&
        collectionHandles.indexOf(
          collectionHandle
        ) !== -1
      );
    }

    return false;
  }

  function findProductForm() {
    return document.querySelector(
      'form[action*="/cart/add"]'
    );
  }

  function renderProductMessage(element) {
    if (
      !/\/products\//.test(
        window.location.pathname
      )
    ) {
      return;
    }

    if (
      !canRenderElement(
        element,
        false
      )
    ) {
      return;
    }

    if (
      !productElementMatches(
        element
      )
    ) {
      return;
    }

    var form =
      findProductForm();

    if (!form) {
      return;
    }

    var existing =
      document.querySelector(
        ".igm-product-message[data-igm-element-id='" +
        String(
          getElementId(element)
        ) +
        "']"
      );

    if (existing) {
      return;
    }

    var box =
      document.createElement(
        "div"
      );

    box.className =
      "igm-product-message";

    box.setAttribute(
      "data-igm-element-id",
      String(
        getElementId(element)
      )
    );

    applyColors(
      box,
      element
    );

    var content =
      makeElementContent(
        element,
        "product"
      );

    if (content) {
      content.classList.add(
        "igm-product-message-text"
      );
    }

    var actions =
      document.createElement(
        "div"
      );

    actions.className =
      "igm-product-message-actions";

    appendActions(
      actions,
      element
    );

    if (
      !appendElementLayout(
        box,
        element,
        content,
        actions
      )
    ) {
      return;
    }

    /*
     * Komunikat produktu można zamknąć tak samo jak popup/belki.
     * Zamknięcie zapisuje stan w sessionStorage przez markClosed(),
     * więc komunikat nie wróci w tej samej sesji.
     */
    box.appendChild(
      makeCloseButton(
        element,
        box
      )
    );

    form.parentNode.insertBefore(
      box,
      form
    );

    sendEvent(
      element,
      "view"
    );
  }

  function isProductListingPage() {
    if (
      /\/products\//.test(
        window.location.pathname
      )
    ) {
      return false;
    }

    return (
      /\/collections\//.test(
        window.location.pathname
      ) ||
      /\/search/.test(
        window.location.pathname
      ) ||
      document.querySelectorAll(
        'a[href*="/products/"]'
      ).length >= 2
    );
  }

  function visibleRect(el) {
    if (
      !el ||
      !el.getBoundingClientRect
    ) {
      return null;
    }

    var rect =
      el.getBoundingClientRect();

    if (
      rect.width < 80 ||
      rect.height < 80
    ) {
      return null;
    }

    if (
      rect.bottom < 0 ||
      rect.top >
        window.innerHeight +
        2000
    ) {
      return null;
    }

    return rect;
  }

  function findImageNearLink(link) {
    var linkRect =
      link.getBoundingClientRect();

    var candidates =
      Array.prototype.slice.call(
        document.querySelectorAll(
          "picture, img"
        )
      );

    var best = null;
    var bestScore = Infinity;

    candidates.forEach(
      function (candidate) {
        var rect =
          visibleRect(candidate);

        if (!rect) return;

        if (
          candidate.closest(
            "#" + ROOT_ID
          )
        ) {
          return;
        }

        if (
          candidate.closest(
            "header"
          )
        ) {
          return;
        }

        if (
          candidate.closest(
            "nav"
          )
        ) {
          return;
        }

        var verticalDistance =
          Math.abs(
            rect.bottom -
            linkRect.top
          );

        var horizontalDistance =
          Math.abs(
            (
              rect.left +
              rect.width / 2
            ) -
            (
              linkRect.left +
              linkRect.width / 2
            )
          );

        if (
          rect.bottom >
          linkRect.top + 60
        ) {
          return;
        }

        if (
          verticalDistance >
          500
        ) {
          return;
        }

        if (
          horizontalDistance >
          Math.max(
            260,
            rect.width
          )
        ) {
          return;
        }

        var score =
          verticalDistance +
          horizontalDistance *
            0.75;

        if (
          score <
          bestScore
        ) {
          bestScore = score;
          best = candidate;
        }
      }
    );

    return best;
  }

  function findProductCardsForBadges() {
    var links =
      Array.prototype.slice.call(
        document.querySelectorAll(
          'a[href*="/products/"]'
        )
      );

    var items = [];
    var seenLinks = {};
    var seenTargets = [];

    links.forEach(
      function (link) {
        var href =
          safeText(
            link.getAttribute(
              "href"
            )
          )
            .split("?")[0]
            .split("#")[0];

        if (
          !href ||
          seenLinks[href]
        ) {
          return;
        }

        seenLinks[href] = true;

        var card =
          link.closest(
            '[class*="gp-product"]'
          ) ||
          link.closest(
            '[class*="GP-PRODUCT"]'
          ) ||
          link.closest(
            ".grid__item"
          ) ||
          link.closest(
            ".product-card"
          ) ||
          link.closest(
            ".card-wrapper"
          ) ||
          link.parentElement;

        var target = null;

        if (card) {
          target =
            card.querySelector(
              "picture"
            ) ||
            card.querySelector(
              "img"
            ) ||
            card.querySelector(
              '[class*="gp-image"]'
            ) ||
            card.querySelector(
              '[class*="gp-relative"]'
            );
        }

        if (!target) {
          target =
            findImageNearLink(
              link
            );
        }

        if (!target) {
          return;
        }

        if (
          target.tagName &&
          target.tagName.toLowerCase() ===
            "img"
        ) {
          target =
            target.parentElement ||
            target;
        }

        if (
          !target ||
          seenTargets.indexOf(
            target
          ) !== -1
        ) {
          return;
        }

        seenTargets.push(
          target
        );

        items.push({
          link: link,
          target: target,
          handle:
            getProductHandleFromLink(
              link
            )
        });
      }
    );

    return items;
  }

  function renderProductBadge(element) {
    if (
      !isProductListingPage()
    ) {
      return;
    }

    if (
      !canRenderElement(
        element,
        false
      )
    ) {
      return;
    }

    var text =
      getElementText(
        element,
        true
      );

    if (!text) {
      return;
    }

    var items =
      findProductCardsForBadges();

    var rendered = 0;

    items
      .slice(0, 80)
      .forEach(function (item) {
        if (
          !productElementMatches(
            element,
            item.handle
          )
        ) {
          return;
        }

        var target =
          item.target;

        if (!target) {
          return;
        }

        if (
          target.querySelector(
            ".igm-product-badge[data-igm-element-id='" +
            String(
              getElementId(element)
            ) +
            "']"
          )
        ) {
          return;
        }

        var computed =
          window.getComputedStyle(
            target
          );

        if (
          computed.position ===
          "static"
        ) {
          target.style.position =
            "relative";
        }

        var badge =
          document.createElement(
            "div"
          );

        badge.className =
          "igm-product-badge igm-product-badge--" +
          safeText(
            element.badge_style ||
            "label"
          );

        badge.setAttribute(
          "data-igm-element-id",
          String(
            getElementId(element)
          )
        );

        applyColors(
          badge,
          element
        );

        badge.textContent =
          text;

        target.appendChild(
          badge
        );

        rendered += 1;
      });

    if (rendered > 0) {
      sendEvent(
        element,
        "view"
      );
    }
  }

  function renderCollectionHero(element) {
    if (
      !/\/collections\//.test(
        window.location.pathname
      )
    ) {
      return;
    }

    if (
      !canRenderElement(
        element,
        false
      )
    ) {
      return;
    }

    if (
      !productElementMatches(
        element
      )
    ) {
      return;
    }

    var existing =
      document.querySelector(
        ".igm-product-message[data-igm-element-id='" +
        String(
          getElementId(element)
        ) +
        "']"
      );

    if (existing) {
      return;
    }

    var main =
      document.querySelector(
        "main"
      ) ||
      document.body;

    var box =
      document.createElement(
        "div"
      );

    box.className =
      "igm-product-message igm-product-message--collection";

    box.setAttribute(
      "data-igm-element-id",
      String(
        getElementId(element)
      )
    );

    applyColors(
      box,
      element
    );

    var content =
      makeElementContent(
        element,
        "collection"
      );

    if (content) {
      content.classList.add(
        "igm-product-message-text"
      );
    }

    var actions =
      document.createElement(
        "div"
      );

    actions.className =
      "igm-product-message-actions";

    appendActions(
      actions,
      element
    );

    if (
      !appendElementLayout(
        box,
        element,
        content,
        actions
      )
    ) {
      return;
    }

    main.insertBefore(
      box,
      main.firstChild
    );

    sendEvent(
      element,
      "view"
    );
  }

  function collectProductCampaignElements(data) {
    var output = [];

    var campaigns =
      Array.isArray(
        data.product_campaigns
      )
        ? data.product_campaigns
        : [];

    campaigns.forEach(
      function (campaign) {
        if (
          Array.isArray(
            campaign.elements
          )
        ) {
          campaign.elements.forEach(
            function (element) {
              output.push(
                normalizeElement(
                  element,
                  campaign
                )
              );
            }
          );
        }
      }
    );

    return output;
  }

  function loadProductCampaigns() {
    fetch(
      PRODUCT_CAMPAIGNS_URL +
      "?t=" +
      Date.now(),
      {
        method: "GET",
        headers: {
          Accept:
            "application/json"
        },
        credentials: "omit",
        cache: "no-store"
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Product campaign API status " +
            response.status
          );
        }

        return response.json();
      })
      .then(function (data) {
        var elements =
          sortElements(
            collectProductCampaignElements(
              data
            )
          );

        elements.forEach(
          function (element) {
            var type =
              getElementType(
                element
              );

            if (
              type ===
              "product_message"
            ) {
              renderProductMessage(
                element
              );
            }

            if (
              type ===
              "banner"
            ) {
              renderProductBadge(
                element
              );
            }

            if (
              type ===
              "product_collection"
            ) {
              renderCollectionHero(
                element
              );
            }
          }
        );
      })
      .catch(function (error) {
        if (
          window.console &&
          window.console.warn
        ) {
          window.console.warn(
            "[IGM product campaigns]",
            error
          );
        }
      });
  }

  ready(function () {
    loadPromotions();
    loadProductCampaigns();
  });
})();